// Customizable Area Start
import React from "react";
import B2bMasterProductController, {
  Props,
  configJSON
} from "./B2bMasterProductController";
import {
  styled,
  Box,
  IconButton,
  Popover,
  TablePagination,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
} from "@material-ui/core";
import {
  ListingPageHeading,
  FilterBox,
  MainButtonComponent,
} from "../../../components/src/customComponents/CustomTags.web";
import {
  renderBaseOnConditions,
  sortStringCondition,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import FilterIcon from "@material-ui/icons/FilterList";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import ExportImportPopover from "../../../components/src/customComponents/ExportImportButton.web";
import { colors } from "../../../blocks/utilities/src/Colors";
import { LoadingComponent } from "../../../components/src/Loader.web";
import SortingTableHeader from "../../../components/src/SortingTableHeader2";
import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DroppableProvided,
  DraggableProvided,
  DraggableStateSnapshot,
} from "react-beautiful-dnd";
import {
  priceListWebStyle,
  TableStyle,
  StyledIconButton,
  StyledTableCell,
  OptionsWrapper,
} from "./CfPriceList.web";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { CustomSnackbar } from "../../../components/src/customComponents/CustomSnackbar.web";
import ProductListingFilters from "../../../../packages/components/src/customComponents/ProductListingFilters.web";
import ConfirmationModal from "../../../components/src/customComponents/ConfirmationModal.web";

// Customizable Area End

// Customizable Area Start
const Strings = configJSON.strings.b2bMasterProductListString;
const Strings2 = configJSON.strings.b2bMasterProductListString;
// Customizable Area End

export default class B2bMasterProduct extends B2bMasterProductController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  getImportExportPopover = () => {
    const { openImportExportPopover } = this.state;
    const open = Boolean(openImportExportPopover);
    const popoverId = open ? "simple-popover" : undefined;
    return (
      <ExportImportPopover
      data-test-id="import-exportId"
        popOverId={popoverId}
        openAction={open}
        popoverOpen={openImportExportPopover}
        popoverClose={() => this.handleCloseImportExportPopver()}
        exportTemplateButtonClick={() => this.handleExportTemplate()}
        importCsvButtonClick={() => this.handleOpenImportModal()}
        exportCsvButtonClick={() => this.handleExportCsv()}
      />
    );
  };

    renderCustomSnackBar = () => {
      const { snackBarOpen, snackBarMessage, severity } = this.state;
  
      return (
        <CustomSnackbar
          data-test-id={"custom-snackbar"}
          open={snackBarOpen}
          onClose={() => this.handleSnackbarClose()}
          autoHideDuration={1000}
          errorMessage={snackBarMessage}
          severity={severity}
          hideIcon={true}
        />
      );
    };
  

  getActionPopover = () => {
    const { openActionPopover ,currentClickedRow,permissionStatus} = this.state;
    const open = Boolean(this.state.openActionPopover);
    const popOverId = open ? "simple-popover" : undefined;
    return (
      <StyledActionPopover
        data-test-id='popver'
        open={open}
        anchorEl={openActionPopover}
        onClose={this.handleCloseActionPopver}
        id={popOverId}
        style={{ boxShadow: "none" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {renderBaseOnConditions(
          permissionStatus.viewPermission || permissionStatus.editPermission ||
          permissionStatus.deactivatePermission ||
            permissionStatus.activatePermission||
           this.state.permissionStatus.deletePermission as boolean,
          <div className={"popoverContainer"}>
            {renderBaseOnConditions(
              this.state.permissionStatus.viewPermission,
              <Box data-test-id="viewButton" onClick={this.handleViewProductMaster} className={"popoverButton"}>{Strings.view}</Box>,
              <></>
            )}
            {renderBaseOnConditions(
              this.state.permissionStatus.editPermission,
              <Box data-test-id="editButton" onClick={this.handleEditProductMaster} className={"popoverButton"}>{Strings.edit}</Box>,
              <></>
            )}
             {renderBaseOnConditions(
              this.state.permissionStatus.deletePermission as boolean,
              <Box data-test-id="editButton" onClick={this.handleOpenDelete} className={"popoverButton"}>{Strings2.delete}</Box>,
              <></>
            )}
            {renderBaseOnConditions(
                          this.state.permissionStatus.deactivatePermission &&
                          currentClickedRow?.attributes?.catalogue_variants[0]?.active,
                          <Box
                            className={"popoverButton"}
                            data-test-id={"deactivate-menu"}
                            onClick={this.handleActivateDeactivate}
                          >
                            {Strings2.deactivate}
                          </Box>,
                          <></>
                        )}
                        {renderBaseOnConditions(
                          (this.state.permissionStatus.activatePermission as boolean) &&
                          !currentClickedRow?.attributes?.catalogue_variants[0]?.active,
                          <Box
                            className={"popoverButton"}
                            data-test-id={"activate-menu"}
                            onClick={this.handleActivateDeactivate}
                          >
                            {Strings2.activate}
                          </Box>,
                          <></>
                        )}
          </div>,
          <div className={"popoverContainer"}>
            <Box className={"noPermissions"}>{Strings.noPermissions}</Box>
          </div>
        )}
      </StyledActionPopover>
    );
  };

  renderDeactivateProductModal = () => {
    const { currentClickedRow, openDeactiveModel } = this.state;
    return (
      <ConfirmationModal
        data-test-id={"deactiveModel"}
        open={openDeactiveModel}
        handleClose={this.handleCloseConfirmModal}
        handleConfirm={this.handleDeactivate}
        title={Strings2.conformDeactiveText}
        message={{
          id: currentClickedRow?.id,
          title: currentClickedRow?.attributes?.product_name
        }}
        confirmText={Strings2.deactivate}
        dynamic={true}
      />
    );
  };

  renderConfirmProdctDeactivateModal = () => {
    const { currentClickedRow, confirmDeactiveModalOpen } = this.state;
    return (
      <ConfirmationModal
        data-test-id={"confirmDeactiveModel"}
        open={confirmDeactiveModalOpen}
        handleClose={this.handleCloseConfirmModal}
        handleConfirm={this.handleGoBackToListing}
        title={Strings2.productDeactivateMessage}
        message={{
          id: currentClickedRow?.id,
          title: currentClickedRow?.attributes?.product_name
        }}
        confirmText={Strings2.confirmButtonText}
        displayItem={true}
      />
    );
  };

  renderDeleteteModal = () => {
    const { currentClickedRow, openDeletePopover } = this.state;
    return (
      <ConfirmationModal
        data-test-id={"deactiveModel"}
        open={openDeletePopover}
        handleClose={this.handleCloseConfirmModal}
        handleConfirm={this.handleDelete}
        title={Strings2.confirmDelete}
        message={{
          id: currentClickedRow?.id,
          title: currentClickedRow?.attributes?.product_name
        }}
        confirmText={Strings2.delete}
        dynamic={true}
      />
    );
  };

  checkSections(data: any, rowId: string) {
    let sections: string[] = [];
    if (data?.length !== 0) {
      data?.map((item: any, index: number) => {
        return sections.push(item?.name)
      })
      return sections.length > 4 ?
        <span data-test-id="sectionNames" style={{ position: 'relative' }} onMouseEnter={() => { this.handleSectionPopupOpen(rowId) }} onMouseLeave={() => { this.handleSectionPopupClose() }}>
          {sections.slice(0, 4).join(", ").substring(0 ,25)}...
          <div style={{ ...priceListWebStyle.sectionPopup, display: `${rowId === this.state.sectionPopupId ? "" : "none"}` }}>
            {sections.join(", ")}
          </div>
        </span> : sections.join(", ").substring(0 ,25)
    }
    else {
      return "--"
    }
  }

  handleServiceListShow (data: any, rowId: string, rowData: any) {
    let serviceStringArray: string[] = [];
    if (data?.length !== 0) {
      data.forEach((item: any) => {
        serviceStringArray.push(item.name);
      });
      const joinedString = serviceStringArray.slice(0).join(", ")
      return serviceStringArray.length > 2 ?
        <span 
          data-test-id={`services-price-${rowId}`}
        >
          {joinedString.substring(0, 80)}{renderBaseOnConditions(joinedString.length <= 80, '','...')}
          <div
            data-test-id="allServiceList"
            style={{ 
              ...priceListWebStyle.servicePopup, 
            display: `${rowId === this.state.servicePopupId ? "" : "none"}` 
          }}
          >
            {serviceStringArray.join(", ").substring(0 ,25)}
          </div>
        </span> : serviceStringArray.join(", ").substring(0)
    } else {
      return "---"
    }
  }
  // Customizable Area End

  render() {
    // Customizable Area Start
    const sortingOpen = Boolean(this.state.openSortingFilterAction);
    const productSortingId = sortingOpen ? "simple-popover" : undefined;
    const { openImportExportPopover, openActionPopover , openDeletePopover , openDeactiveModel,confirmDeactiveModalOpen} = this.state;
    const open = Boolean(openImportExportPopover);
    const popoverId = open ? "simple-popover" : undefined;
    // Customizable Area End
    return (
      // Customizable Area Start
      <BusinessAcountListStyleWrapper>
        <Box className={"topHeaderBox"}>
          <ListingPageHeading>{Strings.headingTitle}</ListingPageHeading>
          <Box className={"topRightBox"}>
            <FilterBox
              data-test-id={"filterBtn"}
              className={sortStringCondition(
                this.isAppliedFilter,
                "active-border",
                ""
              )}
              onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => {this.handleOpenFilter(event)}}
            >
              <FilterIcon color={this.handleReturnColorType()} />
              {renderBaseOnConditions(
                this.isAppliedFilter,
                <div className={"filterActiveIcon"} />,
                <></>
              )}
            </FilterBox>
            <Box>
              <LoadingComponent
                isLoading={this.state.isLoadingPermission}
                height={56}
                width={175}
                isAllowed={true}
                children={
                  <IconButton
                    data-test-id={`export-import-btn`}
                    id={"IconButton"}
                    aria-describedby={popoverId}
                    onClick={(event) => this.openImportExportPopover(event)}
                    className={"export-btn"}
                  >
                    {Strings.exportimportText}{" "}
                    {openImportExportPopover ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                }
              />
              
            </Box>

            <Box>
              <LoadingComponent
                isLoading={this.state.isLoadingPermission}
                height={56}
                width={175}
                isAllowed={true}
                children={
                  <MainButtonComponent className={"mr-0"}  data-test-id="add-price-list"  onClick={this.handleAddB2BPriceList}>
                    {Strings.addPriceList}
                  </MainButtonComponent>
                }
              />
            </Box>

            <Box>
              <LoadingComponent
                isLoading={this.state.isLoadingPermission}
                height={56}
                width={175}
                isAllowed={this.state.permissionStatus.createPermission}
                children={
                  <MainButtonComponent data-test-id="add-product-master" onClick={this.handleAddB2BProduct} className={"mr-0"}>
                    {Strings.addProduct}
                  </MainButtonComponent>
                }
              />
            </Box>
          </Box>
        </Box>

        <Box>
          <TableContainer component={Paper} style={{ overflow: "visible" }}>
            <TableStyle>
              <DragDropContext
                onDragEnd={this.onDragEnd}
                data-test-id='tblDragDrop'
              >
                <Droppable droppableId='droppable'>
                  {(provided: DroppableProvided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      <Table
                        style={priceListWebStyle.table}
                        aria-label='customized table'
                      >
                        <TableHead>
                          <TableRow
                            style={{
                              background: "#204B9C",
                              color: "#FFFFFF",
                              paddingTop: "5px",
                              borderRadius: "5px",
                            }}
                          >
                            <TableCell
                              style={{
                                ...priceListWebStyle.tableHeader,
                                ...priceListWebStyle.actionHeader,
                                ...priceListWebStyle.tableHeaderLeft,
                                width: "3%",
                              }}
                              align='right'
                            />
                            <SortingTableHeader
                              minHeightType={true}
                              titleContainerClassName='headerTxt'
                              title='Product Name'
                              sortingKey='name'
                              width='30%'
                              {...this.getSortingProps()}
                            />
                            <SortingTableHeader
                              minHeightType={true}
                              titleContainerClassName='headerTxt'
                              title='Product Type'
                              sortingKey='type'
                              width='30%'
                              {...this.getSortingProps()}
                            />
                            <SortingTableHeader
                              minHeightType={true}
                              titleContainerClassName='headerTxt'
                              title='Service'
                              sortingKey='service'
                              width='35%'
                              {...this.getSortingProps()}
                            />
                            <SortingTableHeader
                              minHeightType={true}
                              titleContainerClassName='headerTxt'
                              title='Section'
                              sortingKey='sections'
                              width='25%'
                              {...this.getSortingProps()}
                            />
                            <SortingTableHeader
                              minHeightType={true}
                              titleContainerClassName='headerTxt'
                              title='Approx. Weight'
                              sortingKey='approx_weight'
                              width='30%'
                              {...this.getSortingProps()}
                            />
                            <TableCell
                              style={{
                                ...priceListWebStyle.tableHeader,
                                ...priceListWebStyle.actionHeader,
                                ...priceListWebStyle.tableHeaderRight,
                                width: "3%",
                              }}
                              align='right'
                            />
                          </TableRow>
                        </TableHead>
                        <TableBody data-test-id='tblBody'>
                          {this.state.isLoading && (
                            <>
                              {Array(10)
                                .fill(1)
                                .map((_, index) => (
                                  <TableRow
                                    className='tableRow'
                                    data-test-id={index}
                                  >
                                    {[...Array(1)].map((_, cellIndex) => (
                                      <TableRowsSkeleton key={cellIndex} />
                                    ))}
                                  </TableRow>
                                ))}
                            </>
                          )}
                          {!this.state.isLoading &&
                          this.state.dragItem.length !== 0 ? (
                            this.state.dragItem.map(
                              (rowData, index: number) => (
                                <Draggable
                                  key={rowData.id}
                                  draggableId={rowData.id}
                                  index={index}
                                  isDragDisabled={Boolean(
                                    this.state.isDragableDisabled
                                  )}
                                >
                                  {(
                                    provided: DraggableProvided,
                                    snapshot: DraggableStateSnapshot
                                  ) => (
                                    <TableRow
                                      data-test-id={"tableTR"}
                                      key={rowData.id}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                    >
                                      <TableCell
                                        style={{
                                          ...priceListWebStyle.actionCellContainer,
                                          width: "5%",
                                        }}
                                        align='right'
                                        key={rowData.id}
                                        data-test-id={`rowDraggable-${index}`}
                                        {...provided.dragHandleProps}
                                      >
                                        <StyledIconButton>
                                          <DragHandleIcon />
                                        </StyledIconButton>
                                      </TableCell>

                                      <TableCell
                                        data-test-id={"tableTD"}
                                        style={{
                                          ...priceListWebStyle.cellContainer,
                                          width: "30%",
                                          opacity:  this.checkDisabled(rowData.attributes.catalogue_variants[0]?.active)
                                        }}
                                        scope='row'
                                      >
                                        <StyledTableCell className='border-left'>
                                          {rowData.attributes.product_name}
                                        </StyledTableCell>
                                      </TableCell>

                                      <TableCell
                                        style={{
                                          ...priceListWebStyle.cellContainer,
                                          width: "30%",
                                          opacity:  this.checkDisabled(rowData.attributes.catalogue_variants[0]?.active)
                                        }}
                                        align='left'
                                      >
                                        <StyledTableCell
                                          data-test-id={`productType-${rowData.id}`}
                                        >
                                          {
                                            rowData.attributes.product_type
                                              .value
                                          }
                                        </StyledTableCell>
                                      </TableCell>

                                      <TableCell
                                        style={{
                                          ...priceListWebStyle.cellContainer,
                                          width: "35%",
                                          opacity:  this.checkDisabled(rowData.attributes.catalogue_variants[0]?.active)
                                        }}
                                        align='left'
                                      >
                                        <StyledTableCell
                                        style={{padding:"0 5px"}}
                                          data-test-id={`services-${rowData.id}`}
                                        >
                                       {this.handleServiceListShow(rowData.attributes.services, rowData?.id,rowData)}
                                        </StyledTableCell>
                                      </TableCell>

                                      <TableCell
                                      data-test-id={`Sectiondata-${rowData?.id}`}
                                      onMouseEnter={() => { this.hoverToGetRowId(rowData?.id) }}
                                      onMouseLeave={() => { this.removeRowId(0) }}
                                        style={{
                                          ...priceListWebStyle.cellContainer,
                                          width: "35%",
                                          opacity: this.checkDisabled(rowData.attributes.catalogue_variants[0]?.active)
                                        }}
                                        align='left'
                                      >
                                        <StyledTableCell
                                          data-test-id={`sections-${rowData.id}`}
                                        >
                                        {this.checkSections(rowData?.attributes?.sections, rowData?.id)}
                                        </StyledTableCell>
                                      </TableCell>

                                      <TableCell
                                        style={{
                                          ...priceListWebStyle.cellContainer,
                                          width: "25%",
                                          opacity: this.checkDisabled(rowData.attributes.catalogue_variants[0]?.active)
                                        }}
                                        align='left'
                                      >
                                        <StyledTableCell
                                          data-test-id={`approx_weight-${rowData.id}`}
                                          className="border-right"
                                        >
                                          {rowData.attributes.approx_weight}
                                        </StyledTableCell>
                                      </TableCell>

                                      <TableCell
                                        style={{
                                          ...priceListWebStyle.actionCellContainer,
                                          width: "5%",
                                        }}
                                        align='right'
                                      >
                                        <OptionsWrapper>
                                          <IconButton
                                            data-test-id={"more-menu-button"}
                                            id={"IconButton" + index}
                                            onClick={(event) => this.handleOpenActionPopver(event,rowData.id, rowData.attributes.catalogue_variants[0].price_list_id,rowData)}
                                          >
                                            <MoreVertIcon />
                                          </IconButton>
                                        </OptionsWrapper>
                                      </TableCell>
                                      
                                    </TableRow>
                                  )}
                                </Draggable>
                              )
                            )
                          ) : (
                            !this.state.isLoading &&   <TableRow>
                              <TableCell
                                style={priceListWebStyle.nodataCellContainer}
                                align='left'
                                colSpan={5}
                              >
                                <div
                                  style={{
                                    ...priceListWebStyle.noDataCell,
                                    textAlign: "center",
                                  }}
                                >
                                  No product were found
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                          {provided.placeholder}
                        </TableBody>
                      </Table>
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </TableStyle>
          </TableContainer>
        </Box>

        {renderBaseOnConditions(
          this.state.dragItem?.length !== 0 ,
          <TablePagination
            data-test-id='productListPagination'
            rowsPerPageOptions={[10]}
            component='div'
            count={this.state.productListPagination?.total_count}
            rowsPerPage={this.state.pageSize}
            page={this.state.page}
            onPageChange={(event, page) => { this.handlePageChange(page) }}
          />,
          <></>
        )}
        {openActionPopover && this.getActionPopover()}
        {openImportExportPopover && this.getImportExportPopover()}
        {this.state.snackBarOpen && this.renderCustomSnackBar()}
        {openDeletePopover && this.renderDeleteteModal()}
        {openDeactiveModel && this.renderDeactivateProductModal()}
        {confirmDeactiveModalOpen && this.renderConfirmProdctDeactivateModal()}

        {sortingOpen && <ProductListingFilters
                      data-test-id="productFilter"
                      productSortingId={productSortingId}
                      sortingOpen={sortingOpen}
                      sortingClose={(closeValue: boolean) => { this.handleFilterPopupClose(closeValue) }}
                      anchor={this.state.openSortingFilterAction}
                      selectedFilter={this.state.selectedFilter}
                      handleSelectedFilter={(value: number, nameValue: string) => this.handleFilterChange(value, nameValue)}
                      priceRangeValue={this.state.priceRangeValue}
                      handleApplyFilter={this.handleApplyFilterChange}
                      subFilterMenuList={this.state.dropdownOptions}
                      handleClearFitler={() => this.handleClearFitler()}
                      nameFilter={this.state.nameFilter}
                      setName={this.setName}
                      priceFilter={null}
                      setPrice={()=>{}}
                      sectionFilter={this.state.sectionFilter}
                      setSection={this.setSection}
                      productTypeFilter={this.state.productTypeFilter}
                      setProductType={this.setProductType}
                      preferenceFilter={this.state.preferenceFilter}
                      setPreference={this.setPreference}
                      optionsList={this.state.optionsList}
                      isAnyDataNotSee={["price"]}
                    />}
      </BusinessAcountListStyleWrapper>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const BusinessAcountListStyleWrapper = styled(Box)({
  width: "100%",
  "& .topHeaderBox": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "17px 0 32px 0",
  },
  "& .topRightBox": {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  "& .tableBodyLoader": {
    textAlign: "center",
    paddingBottom: 15,
  },
  "& .noDataFound": {
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "Montserrat",
    textAlign: "center",
    padding: "8px 0 12px 0",
  },
  "& .viewStatusButton": {
    padding: "4px 10px",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: 600,
    color: colors().cyancobaltblue,
    background: "rgba(32, 75, 156, 0.1)",
    fontFamily: "Montserrat",
    textTransform: "capitalize",
    cursor: "pointer",
  },
  "& .moreMenuButton": {
    padding: "5px",
    borderRadius: "8px",
    textAlign: "center",
    color: colors().viewTextColor,
    background: "rgba(32, 75, 156, 0.1)",
    cursor: "pointer",
  },
  "& .bottomStatusCell": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  "& .statusLastColumn": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "12px",
  },
  "& .tablePaginationBox": {
    width: "100%",
    padding: "8px 0",
  },
  "& .export-btn": {
    width: "auto !important",
    margin: "0 10px",
    background: colors().cyancobaltblue,
    fontWeight: 600,
    fontSize: "16px !important",
    lineHeight: "24px",
    color: colors().white,
    height: "56px",
    borderRadius: "8px",
    textTransform: "unset",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "13px !important",
      width: "160px !important",
      height: "44px !important",
    },
  },
});

const StyledActionPopover = styled(Popover)({
  "& .noPermissions": {
    padding: "0 8px",
  },
  "& .popoverButton": {
    cursor: "pointer",
    width: "118px",
    height: "33px",
    paddingLeft: "24px",
    paddingTop: "8px",
    backgroundColor: "#FFFFFF",
    color: "#4D4D4D",
    "&:hover": {
      backgroundColor: "#204B9C",
      color: "#FFFFFF",
    },
  },
  "& .popoverContainer": {
    paddingTop: "16px",
    paddingBottom: "16px",
    boxShadow:
      "0px 4px 8px rgba(0, 0, 0, 0.03), 0px 8px 32px rgba(0, 0, 0, 0.06)",
    borderRadius: "8px",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "14px",
  }  
});
// Customizable Area End
